<template>
  <div id="mapBox">
    <center-vedio v-show="showVedio" ref="centerVedio" @showMapBar="MapInfo"/>
    <baidu-map
      class="box"
      @ready="handler"
      :map-click="false"
      v-if="showMap">
      <bml-marker-clusterer :averageCenter="true">
        <div v-for="(marker, i) of markList" :key="i">
          <bm-marker :icon="{url: marker.url, size: { width: 22, height: 33 }}" :position="{lng: marker.lng, lat: marker.lat}" @click="infoWindowOpen(marker)">
            <bm-info-window :title="name"   :position="{lng: marker.lng, lat: marker.lat}" :show="marker.showFlag" @close="infoWindowClose(marker)" style="font-size: 12px;text-align: center; color: #ffffff">
              <table>
                <tr v-for="(device, i) in valueList">
                  <td>{{device.name}}：</td>
                  <td>{{device.value}}</td>
                </tr>
              </table>
            </bm-info-window>
          </bm-marker>
        </div>
      </bml-marker-clusterer>
    </baidu-map>
  </div>
</template>

<script>
  // 按需引入点聚合
  import {BmlMarkerClusterer} from 'vue-baidu-map'
  import centerVedio from "./centerVedio";
  // 引入marker
  import BmMarker from 'vue-baidu-map/components/overlays/Marker'

  import {
    getAttributesServer,
    getAttributesShared,
    getCredentials,
    getDeviceKey,
    getDeviceName,
    getDeviceValue,
    getConnectTime
  } from "../untils/api/home";
  import moment from "moment";

  export default {
    name: "CenterMap",
    components: {
      BmlMarkerClusterer,
      BmMarker,
      centerVedio
    },
    data () {
      return {
        BMap: '',
        map: '',
        markList:[], //全部点
        show: false,
        option1: {lat: '', lng: '', url:'', showFlag: false, device:{}}, //服务端经纬度数据
        latFlg1: false, //服务端纬度标识符
        lngFlg1: false ,//服务端经度标识符
        option2: {lat: '', lng: '', url:'', showFlag: false, device:{}}, //共享端经纬度数据
        latFlg2: false, //共享端纬度标识符
        lngFlg2: false, //共享端经度标识符
        option3: {lat: '', lng: '', url:'', showFlag: false, device:{}}, //最新遥测经纬度数据
        latFlg3: false, //最新遥测数据纬度标识符
        lngFlg3: false, // 最新遥测数据经度标识符
        name:'',
        valueList: [],
        lat: 0,
        lng: 0,
        time:'',
        shareList: [],
        showMap: true,
        showVedio: false,
        defaultDeviceId: ''
      }
    },

    beforeDestroy() {
      clearInterval(this.time);
    },

    methods: {
      handler({BMap, map}) {
        map.enableScrollWheelZoom(true);

        map.centerAndZoom(new BMap.Point(103.817535, 36.132308), 1);
        //map.centerAndZoom(new BMap.Point(118.487395, 33.731492), 10);

        this.BMap = BMap;
        this.map = map;
        map.addControl(new BMap.ScaleControl());
        // map.addControl(new BMap.OverviewMapControl());
        // map.addControl(new BMap.MapTypeControl({mapTypes: [BMAP_NORMAL_MAP,BMAP_SATELLITE_MAP,BMAP_HYBRID_MAP]}));
        if(localStorage.getItem('locale') === 'en-US'){
          map.setMapType(BMAP_SATELLITE_MAP);
        }else {
          map.addControl(new BMap.MapTypeControl({mapTypes: [BMAP_NORMAL_MAP,BMAP_SATELLITE_MAP,BMAP_HYBRID_MAP]}));
        }

        function Enlarge(){
          // 设置默认停靠位置和偏移量
          this.defaultAnchor = BMAP_ANCHOR_TOP_LEFT;
          this.defaultOffset = new BMap.Size(10,10);
        }

        //通过该属性继承BMap控件
        Enlarge.prototype=new BMap.Control();

        //必须实现控件的初始化事件，因为当你把控件添加到地图中会首先初始化kong'j
        Enlarge.prototype.initialize=function(map){
          let flg = false;
          //创建DOM对象
          let div = document.createElement("img");
          div.style.cursor="pointer";
          div.src =  require('./img/enlarge3.png');
          div.style.width = "32px";
          div.style.height = "32px";
          // 绑定事件
          div.onclick=function(e){
            if(!flg){
              flg = true;
              div.src =  require('./img/narrow3.png');
              let element = document.getElementById("mapBox");
              if(element.requestFullscreen){
                element.requestFullscreen()
              } else if(element.wekitRequestFullscreen) {
                element.wekitRequestFullscreen();
              } else if(element.mozRequestFullscreen){
                element.mozRequestFullscreen();
              }else if(element.msRequestFullscreen){
                element.msRequestFullscreen();
              }
            } else if(flg){
              flg = false;
              div.src =  require('./img/enlarge3.png');
              let element = document.getElementById("mapBox");
              if(document.exitFullscreen()){
                document.exitFullscreen()
              } else if(document.wekitCancelRequestFullscreen) {
                document.wekitCancelRequestFullscreen();
              } else if(document.mozCancelFullscreen){
                element.mozCancelFullscreen();
              }else if(element.msExitFullscreen){
                element.msExitFullscreen();
              }
            }

          }
          //添加该控件到地图中
          map.getContainer().appendChild(div);
          return div;
        }

        const _this = this;
        function Vedio(){
          // 设置默认停靠位置和偏移量
          this.defaultAnchor = BMAP_ANCHOR_TOP_LEFT;
          this.defaultOffset = new BMap.Size(50,10);
        }

        //通过该属性继承BMap控件
        Vedio.prototype=new BMap.Control();

        //必须实现控件的初始化事件，因为当你把控件添加到地图中会首先初始化kong'j
        Vedio.prototype.initialize=function(map){
          //创建DOM对象
          let div = document.createElement("img");
          div.style.cursor="pointer";
          div.src =  require('./img/vedio1.png');
          div.style.width = "36px";
          div.style.height = "36px";
          // 绑定事件
          // div.onclick= ((e) => {
          //   _this.showMap = false;
          //   _this.showVedio = true;
          // });
          div.onclick=function(e){
            _this.showMap = false;
            _this.showVedio = true;
          }
          //添加该控件到地图中
          map.getContainer().appendChild(div);
          return div;
        }

        let enlarge = new Enlarge();
        map.addControl(enlarge);
        let vedio = new Vedio();
        map.addControl(vedio);
      },

      /**
       * 接收home页面传递某个设备的最新遥测数据获取经纬度
       * @param deviceResponse
       */
      getDeviceDataInfos(deviceId,deviceResponse) {
        //将最新遥测的经纬度添加到集合
        this.setResponsePoint(deviceId,deviceResponse);
        if(this.defaultDeviceId !== deviceId.id){
          this.$refs.centerVedio.getSelectDevice(deviceId);
          this.defaultDeviceId = deviceId.id;
        }
      },

      /**
       * 接收home页面传递的设备集合获取经纬度
       * @param deviceBoards
       */
      getDeviceInfos(deviceBoards) {
        this.markList = [];
        //将服务端的经纬度添加到集合
        this.setServerOption(deviceBoards);
        //将共享端的经纬度添加到集合
        this.setSharedPoint(deviceBoards);
        //每隔三小时访问一次
        this.time = window.setInterval(() => {
          setTimeout(() => {
            this.markList = [];
            //将服务端的经纬度添加到集合
            this.setServerOption(deviceBoards);
            //将共享端的经纬度添加到集合
            this.setSharedPoint(deviceBoards);
          }, 0)
        },1000 * 60 *60 * 3);
        console.log("markList", this.markList);
      },

      /**
       * 将服务端的经纬度添加到集合
       * @param deviceBoards
       */
      setServerOption(deviceBoards){
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
        // let beforeTime =   new Date(moment().subtract(3, "days")).getTime();
        let offLine = 0;
        let flg = true;
        // 访问api获取数据
        for (let i = 0; i < deviceBoards.length; i++) {
          getAttributesServer(deviceBoards[i].type, deviceBoards[i].id).then(response => {
            //遍历每一条数据
            for (let j = 0; j < response.length; j++) {
              //当前对象为纬度 赋值
              if (response[j].key === 'latitude') {
                this.option1.lat = response[j].value;
                // this.option1.url = require("./img/bg3.png");
                this.option1.device = deviceBoards[i];
                this.latFlg1 = true;
              }else if(response[j].key === 'longitude'){
                //当前对象为纬度赋值
                this.option1.lng = response[j].value;
                this.lngFlg1 = true;
              }
              if(response[j].key === 'lastActivityTime'){
                if(response[j].value <= beforeTime){
                  // this.option1.url = require("./img/bg6.png");
                  this.option1.url = require("./img/bg7.png");
                  flg = false;
                  offLine++;
                  this.$emit("callBackInfo", offLine);
                } else {
                  // this.option1.url = require("./img/bg3.png");
                  this.option1.url = require("./img/bg8.png");
                }
              }
              //经度纬度数据赋值给集合并将标识符以及变量清空
              if(this.lngFlg1 && this.latFlg1){
                this.markList.push(this.option1);
                this.option1 = {lat: '', lng: '', url:'', showFlag: false, device:{}};
                this.latFlg1 = false;
                this.lngFlg1 = false;
              }
            }
          }).catch(error => {
            console.log("error", error)
          })
        }
        if(flg) {
          this.$emit("callBackInfo", 0);
        }
      },

      /**
       * 将共享端的经纬度添加到集合
       * @param deviceBoards
       */
      setSharedPoint(deviceBoards) {
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
        // let beforeTime =   new Date(moment().subtract(3, "days")).getTime();
        Promise.all([
          //获取每一个设备最后一次连接时间
          this.getTime(deviceBoards),
        ]).then(res => {
          //遍历循环出每一个设备
          for(let i = 0; i < deviceBoards.length; i++){
            //访问api获取数据
            getAttributesShared(deviceBoards[i].type, deviceBoards[i].id).then(response => {
              //遍历每一条数据
              for(let j = 0; j < response.length; j++){
                //是否离线标识符
                let flag = false;
                //当前对象为纬度 赋值
                if(response[j].key === 'latitude') {
                  this.option2.lat = response[j].value;
                  this.option2.device = deviceBoards[i];
                  this.latFlg2 = true;
                  //循环查找出当前设备是否离线
                  for(let z = 0; z < this.shareList.length; z++){
                    if(this.shareList[z].id === deviceBoards[i].id){
                      this.shareList[z].value < beforeTime ? flag = true : flag = false;
                      break;
                    }
                  }
                  //根据设备是否离线设置不同坐标
                  if(flag){
                    // this.option2.url = require("./img/bg6.png");
                    this.option2.url = require("./img/bg7.png");
                  } else {
                    // this.option2.url = require("./img/bg3.png");
                    this.option2.url = require("./img/bg8.png");
                  }
                  // this.option2.url = require("./img/bg3.png");
                }else if(response[j].key === 'longitude'){
                  //当前对象为纬度赋值
                  this.option2.lng = response[j].value;
                  this.lngFlg2 = true;
                }
                //经度纬度数据赋值给集合并将标识符以及变量清空
                if(this.lngFlg2 && this.latFlg2){
                  this.markList.push(this.option2);
                  this.option2 = {lat: '', lng: '', url:'', showFlag: false, device:{}};
                  this.latFlg2 = false;
                  this.lngFlg2 = false;
                }
              }
            }).catch(error => {
              console.log("error", error)
            })
          }
        })
      },

      /**
       * 获取每一个设备最后一次连接时间
       * @param deviceBoards
       */
      getTime(deviceBoards){
        this.shareList = [];
        for(let i = 0; i < deviceBoards.length; i++){
          getConnectTime(deviceBoards[i].type, deviceBoards[i].id).then(response => {
            let shareJson = {};
            shareJson.id = deviceBoards[i].id;
            shareJson.value = response[0].value;
            this.shareList.push(shareJson);
          }).catch(error => {
            console.log("error", error)
          })
        }
      },

      /**
       * 将最新遥测的经纬度添加到集合
       * @param deviceResponse
       */
      setResponsePoint(deviceId,deviceResponse){
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
        // let beforeTime =   new Date(moment().subtract(3, "days")).getTime();
        let time = 0;
        Promise.all([
          getConnectTime(deviceId.entityType, deviceId.id).then(response => {
            time = response[0].value;
          }).catch(error => {
            console.log("error", error)
          })
        ]).then(() => {
          for(let obj in deviceResponse){
            //当前对象为纬度 赋值
            if(obj === 'latitude'){
              this.option3.lat = parseFloat(deviceResponse[obj][0].value) + 0.00328;
              this.lat = parseFloat(deviceResponse[obj][0].value) + 0.00328;
              // this.option3.url = require("./img/bg3.png");
              if(time < beforeTime){
                // this.option3.url = require("./img/bg6.png");
                this.option3.url = require("./img/bg7.png");
              } else {
                // this.option3.url = require("./img/bg3.png");
                this.option3.url = require("./img/bg8.png");
              }
              this.option3.device = deviceId;
              this.latFlg3 = true;
            }else if(obj === 'longitude' && this.lng !== parseFloat(deviceResponse[obj][0].value)){
              //当前对象为纬度赋值
              this.option3.lng =  parseFloat(deviceResponse[obj][0].value) + 0.01185;
              this.lng = parseFloat(deviceResponse[obj][0].value) + 0.01185;
              this.lngFlg3 = true;
            }
            //经度纬度数据赋值给集合并将标识符以及变量清空
            if(this.lngFlg3 && this.latFlg3){
              //this.markList.push(this.option3);
              let deviceId = this.option3.device.id;
              let existingIndex = this.markList.findIndex(item => item.device.id === deviceId);
              if (existingIndex !== -1) {
                // 如果找到，则更新对应的对象
                this.markList[existingIndex].lat = this.option3.lat;
                this.markList[existingIndex].lng = this.option3.lng;
                this.markList[existingIndex].url = this.option3.url;
                this.markList[existingIndex].showFlag = false;
                this.markList[existingIndex].device = this.option3.device;
              } else {
                // 如果未找到，则添加新对象
                this.markList.push(this.option3);
              }
              this.option3 = {lat: '', lng: '', url:'', showFlag: false, device:{}};
              this.latFlg3 = false;
              this.lngFlg3 = false;
            }
          }
        })
      },
      /**
       * 关闭弹窗
       * @param marker
       */
      infoWindowClose (marker) {
        marker.showFlag = false;
      },

      /**
       * 打开弹窗 #40faee #f07c1e 0AD18C 0A935C FA861E
       * @param marker
       */
      infoWindowOpen (marker) {
        marker.showFlag = true;
        this.name = marker.device.name === undefined ? this.getDeviceName(marker.device.id) :
          '<span style="font-size: 18px; font-weight: bold; margin-top: 10px; color: #FA861E">' + marker.device.name + '</span>';
        this.getCenDevice(marker.device);
      },

      /**
       * 根据选中的值获取设备数据
       * @param devicesInfo
       */
      getCenDevice(devicesInfo) {
        //访问api获取设备信息
        getCredentials(devicesInfo.id).then(response => {
          let deviceId = response.deviceId;
          //根据设备id获取亚遥测数据key值
          this.getCenDeviceKey(deviceId)
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取遥感key值
       * @param deviceId
       */
      getCenDeviceKey(deviceId) {
        //访问api 获取设备key
        getDeviceKey(deviceId.entityType, deviceId.id).then(response => {
          let deviceKey = '';
          let pattern = /^[A-Za-z0-9.]+$/;
          //判断key是否存在
          response.length === 0 ? deviceKey = 'false' : deviceKey = '';
          //key 存在遍历取出 转成字符串
          for (let i = 0; i <= response.length -1; i++) {
            if (pattern.test(response[i])) {
              i === response.length -1 ? deviceKey += response[i] : deviceKey += response[i] + ','
            }
          }

          //根据 设备id 遥测key 获取最新遥测value
          this.getCenNewDevice(deviceId, deviceKey);

        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 获取最新遥测数据
       * @param deviceId
       * @param deviceKey
       */
      getCenNewDevice(deviceId, deviceKey){
        let deviceIdArray = [
          '6cccb080-6b34-11ef-be5a-c3f034c6f7c8', '6f5a94c0-6f0d-11ef-bc47-d7ca6124c18c', '460c79b0-6f0f-11ef-bc47-d7ca6124c18c', '22e72390-6f1e-11ef-bc47-d7ca6124c18c',
          'cf050a80-6f22-11ef-bc47-d7ca6124c18c', '37e40a20-6f3b-11ef-bc47-d7ca6124c18c', '5f816090-6f3c-11ef-bc47-d7ca6124c18c', '91731250-6f4c-11ef-bc47-d7ca6124c18c',
          'f398ed80-6f4f-11ef-bc47-d7ca6124c18c', '481d6660-7022-11ef-86be-f95d7c5e0879', '71787260-7023-11ef-86be-f95d7c5e0879', '2fd0d860-70f1-11ef-b67f-bfb38aaf3828',
          '4c7b42f0-717a-11ef-b67f-bfb38aaf3828', '70b11450-718f-11ef-b67f-bfb38aaf3828', 'e6751a22-7193-11ef-b67f-bfb38aaf3828', 'bf0c5550-719f-11ef-b67f-bfb38aaf3828',
          '27f06dc0-71a7-11ef-b67f-bfb38aaf3828', '00258130-71b2-11ef-b67f-bfb38aaf3828', '47a563c0-7231-11ef-b67f-bfb38aaf3828', 'af098100-723a-11ef-8ff4-7d3b1806288b',
          'ce970100-7244-11ef-8ff4-7d3b1806288b', '9cecea50-725a-11ef-8ff4-7d3b1806288b', '3fe425e1-7263-11ef-8ff4-7d3b1806288b', 'bcbdfed0-726b-11ef-8ff4-7d3b1806288b',
          '60821cc0-7273-11ef-8ff4-7d3b1806288b', 'e897f2e1-727f-11ef-8ff4-7d3b1806288b', '5d57cb80-72fa-11ef-95df-0b4de8795e45', '3e81c060-730b-11ef-95df-0b4de8795e45',
          'e576c005-731f-11ef-95df-0b4de8795e45', 'ddf0ec00-7326-11ef-95df-0b4de8795e45', '161573a0-732a-11ef-95df-0b4de8795e45', 'a80957e0-732a-11ef-95df-0b4de8795e45',
          '9c845181-732b-11ef-95df-0b4de8795e45', '5339d8f0-732c-11ef-95df-0b4de8795e45', '0fa5c760-732d-11ef-95df-0b4de8795e45'];
        this.valueList = [];
        if(deviceIdArray.includes(deviceId.id)) {
          //key存在访问api
          getDeviceValue(deviceId.entityType, deviceId.id, deviceKey).then(response => {
            let i = 0;
            for (let obj in response) {
              if(i === 5) return;
              let arrList = {};
              arrList.name = this.$t(obj).split(',')[0];
              // this.$t(obj).split(',')[1] === undefined ? arrList.value = parseFloat(response[obj][0].value).toFixed(2)
              //   : arrList.value = parseFloat(response[obj][0].value).toFixed(2) + this.$t(obj).split(',')[1];
              // this.valueList.push(arrList);
              if(obj == 'Amnitro') {
                if(this.$t(obj).split(',')[1] === undefined) {
                  arrList.value = this.calculateWater(0, 8, parseFloat(response[obj][0].value)).toFixed(2);
                } else {
                  arrList.value =this.calculateWater(0, 8, parseFloat(response[obj][0].value)).toFixed(2) + this.$t(obj).split(',')[1];
                }
              } else if(obj == 'dissolvedoxygen') {
                if(this.$t(obj).split(',')[1] === undefined) {
                  arrList.value = this.calculateWater(2, 10, parseFloat(response[obj][0].value)).toFixed(2);
                } else {
                  arrList.value = this.calculateWater(2, 10, parseFloat(response[obj][0].value)).toFixed(2) + this.$t(obj).split(',')[1];
                }
              } else if(obj == 'Opacity') {
                if(this.$t(obj).split(',')[1] === undefined) {
                  arrList.value = this.calculateWater(251, 1000, parseFloat(response[obj][0].value)).toFixed(0);
                } else {
                  arrList.value = this.calculateWater(251, 1000, parseFloat(response[obj][0].value)).toFixed(0) + this.$t(obj).split(',')[1];
                }
              } else if(obj == 'oRp') {
                if(this.$t(obj).split(',')[1] === undefined) {
                  arrList.value = this.calculateWater(50, 500, parseFloat(response[obj][0].value)).toFixed(0);
                } else {
                  arrList.value = this.calculateWater(50, 500, parseFloat(response[obj][0].value)).toFixed(0) + this.$t(obj).split(',')[1];
                }
              }
              this.valueList.push(arrList);
              i++;
            }
          }).catch(error => {
            console.log("error", error)
          })
        } else {
          //key存在访问api
          getDeviceValue(deviceId.entityType, deviceId.id, deviceKey).then(response => {
            let i = 0;
            for (let obj in response) {
              if(i === 5) return;
              let arrList = {};
              arrList.name = this.$t(obj).split(',')[0];
              this.$t(obj).split(',')[1] === undefined ? arrList.value = parseFloat(response[obj][0].value).toFixed(2)
                : arrList.value = parseFloat(response[obj][0].value).toFixed(2) + this.$t(obj).split(',')[1];
              this.valueList.push(arrList);
              i++;
            }
          }).catch(error => {
            console.log("error", error)
          })
        }

      },

      /**
       * 获取设备名称#40faee #f07c1e 0AD18C 0A935C #565656 FA861E
       * @param deviceId
       */
      getDeviceName(deviceId){
        getDeviceName(deviceId).then(response => {
          this.name = '<span style="font-size: 18px; font-weight: bold; margin-top: 10px; color: #FA861E">' + response.name +'</span>';
        }).catch(error => {
          console.log("error", error)
        })
      },

      MapInfo(data) {
        this.showVedio = false;
        this.showMap = true;
      },

      calculateWater(min, max, value) {
        value = Math.abs(value);
        if(value == 0) value += 1;
        if (value >= min && value <= max) {
          return value; // 直接返回原值
        }

        if (value < min) {
          let multiplier = 2;
          while (value < min) {
            value *= multiplier;
            if (value >= min) break;
            multiplier = Math.min(multiplier + 1, max / min); // 限制 multiplier 递增幅度
          }
        } else if (value > max) {
          let divisor = 2;
          while (value > max) {
            value /= divisor;
            if (value <= max) break;
            divisor = Math.min(divisor + 1, max / min); // 限制 divisor 递增幅度
          }
        }

        return Math.min(Math.max(value, min), max); // 确保最终值在区间内
      },

      // 插入 100 个随机点 例子
      // setMarks(){
      //   for (let i = 0; i < 100; i++) {
      //     const position = {lat: Math.random() * 30 + 21, lng: Math.random() * 40 + 85,  url:require("./img/bg3.png"), showFlag: false }
      //     this.markers.push(position);
      //   }
      // },
    }

  };
</script>
<style lang="less" scoped>
  @import "less/centerMap.less";
</style>



// WEBPACK FOOTER //
// src/components/CenterMap.vue